import type { RouteProps } from '../types'

export function Route(_props: RouteProps) {
    return null
}
